export const zahlartenDe = {
  'zahlarten.header.title': 'Zahlungsarten',
  'zahlarten.header.subtitle': 'Verwalten Sie Zahlungsmethoden, deren DATEV-Zuordnung und den Zahlweg für Eingangsrechnungen',
  'zahlarten.header.newButton': 'Neue Zahlungsart',
  'zahlarten.readOnlyHint': 'Nur ansehen — zum Anlegen, Bearbeiten, Löschen oder Sortieren wird die Berechtigung „Einstellungen bearbeiten" benötigt.',

  'zahlarten.table.name': 'Name',
  'zahlarten.table.code': 'Code',
  'zahlarten.table.type': 'Typ',
  'zahlarten.table.zahlweg': 'Zahlweg',
  'zahlarten.table.zahlwegTooltip': 'Womit könnten WIR (der Betrieb) mit dieser Zahlart eine Eingangsrechnung begleichen? Steuert, ob sie beim Bezahlt-Markieren einer Eingangsrechnung angeboten wird.',
  'zahlarten.table.provider': 'Anbieter',
  'zahlarten.table.datevAccount': 'DATEV-Konto',
  'zahlarten.table.active': 'Aktiv',
  'zahlarten.table.actions': 'Aktionen',
  'zahlarten.table.empty': 'Keine Zahlungsarten vorhanden',
  'zahlarten.table.standardBadge': 'Standard',
  'zahlarten.table.setZahlwegBadge': 'Zahlweg festlegen',
  'zahlarten.table.editTitle': 'Bearbeiten',
  'zahlarten.table.deleteTitle': 'Löschen',

  'zahlarten.modal.editTitle': 'Zahlungsart bearbeiten',
  'zahlarten.modal.createTitle': 'Neue Zahlungsart',
  'zahlarten.modal.nameLabel': 'Name *',
  'zahlarten.modal.namePlaceholder': 'z.B. PayPal',
  'zahlarten.modal.descriptionLabel': 'Beschreibung',
  'zahlarten.modal.descriptionPlaceholder': 'Optionale Beschreibung',
  'zahlarten.modal.typeLabel': 'Typ',
  'zahlarten.modal.providerLabel': 'Anbieter',
  'zahlarten.modal.providerPlaceholder': 'z.B. PayPal, Klarna',

  'zahlarten.modal.zahlwegLabel': 'Zahlweg für Eingangsrechnungen *',
  'zahlarten.modal.zahlwegTooltip': 'Womit könnten WIR (der Betrieb) mit dieser Zahlart eine Eingangsrechnung eines Lieferanten begleichen? Bestimmt, ob diese Zahlart beim Bezahlt-Markieren einer Eingangsrechnung zur Auswahl steht. "Keine" für reine Verkaufswege (z. B. Rechnungskauf durch unsere Kunden, Gutschein) — damit lässt sich keine eigene Verbindlichkeit tilgen.',
  'zahlarten.modal.zahlwegPlaceholder': 'Bitte auswählen …',
  'zahlarten.zahlwegOptions.kasse': 'Kasse (bar)',
  'zahlarten.zahlwegOptions.bank': 'Bank (Überweisung/Lastschrift)',
  'zahlarten.zahlwegOptions.verrechnung': 'Verrechnung (Skonto, Gutschrift des Lieferanten, …)',
  'zahlarten.zahlwegOptions.keine': 'Keine — reiner Verkaufsweg (z. B. Rechnungskauf, Gutschein)',
  'zahlarten.zahlwegKurz.kasse': 'Kasse',
  'zahlarten.zahlwegKurz.bank': 'Bank',
  'zahlarten.zahlwegKurz.verrechnung': 'Verrechnung',
  'zahlarten.zahlwegKurz.keine': 'Keine',

  'zahlarten.modal.datevAccountLabel': 'DATEV-Kontonummer',
  'zahlarten.modal.datevAccountTooltip': 'Konto, auf das die Kasse Zahlungen dieser Art bucht. Beispiele SKR03: 1000 = Kasse, 1360 = EC-Geldtransit, 1400 = Forderungen aus LuL (Rechnungskauf), 1200 = Bank. SKR04: 1600 / 1460 / 1200 / 1800.',
  'zahlarten.modal.datevAccountPlaceholderInvoice': '1400 (SKR03)',
  'zahlarten.modal.datevAccountPlaceholderOther': 'z.B. 1360',
  'zahlarten.modal.datevBuKeyLabel': 'DATEV BU-Schlüssel',
  'zahlarten.modal.datevBuKeyPlaceholder': 'z.B. 10',

  'zahlarten.modal.invoicePaymentLabel': 'Rechnungskauf (Kunde zahlt später per Rechnung)',
  'zahlarten.modal.invoicePaymentTooltip': "Aktivieren, wenn diese Zahlart bedeutet, dass der Kunde die Ware später per Rechnung bezahlt (z.B. 'Auf Rechnung', 'Auf Ziel', 'B2B-Rechnung'). Die Kasse bucht dann KEINEN Erlös im DATEV-Export — der Umsatz wird ausschließlich von der Warenwirtschaft beim Rechnungslauf gebucht. So vermeiden wir doppelte Umsatzbuchungen.",
  'zahlarten.modal.invoicePaymentHint': 'Kasse erfasst den Vorgang TSE-konform, bucht aber keinen Erlös. Empfehlung: DATEV-Konto 1400 (SKR03) / 1200 (SKR04) für Forderungen aus LuL.',

  'zahlarten.modal.shipBeforePaymentLabel': 'Versand vor Zahlungseingang',
  'zahlarten.modal.shipBeforePaymentTooltip': 'Darf Ware mit dieser Zahlungsart das Haus verlassen, bevor das Geld eingegangen ist? Bei Rechnungskauf und Nachnahme ist das üblich, bei Vorkasse nicht. Aufträge, die es nicht dürfen, erscheinen am Handheld gar nicht erst zum Kommissionieren. Abholaufträge sind davon nicht betroffen — dort wird bei der Übergabe kassiert.',
  'zahlarten.shipBefore.unsetTitle': 'Nicht festgelegt',
  'zahlarten.shipBefore.unsetText': 'Es gilt der aus JTL übernommene Wert. Ohne JTL-Angabe bleibt unbezahlte Ware gesperrt, bis der Auftrag als bezahlt markiert ist.',
  'zahlarten.shipBefore.allowedTitle': 'Erlaubt',
  'zahlarten.shipBefore.allowedText': 'Ware darf raus, obwohl noch nicht gezahlt wurde — für Rechnungskauf, Nachnahme oder Kunden mit Zahlungsziel.',
  'zahlarten.shipBefore.notAllowedTitle': 'Nicht erlaubt',
  'zahlarten.shipBefore.notAllowedText': 'Erst wenn das Geld da ist. Der Auftrag erscheint bis dahin nicht in der Kommissionierung.',

  'zahlarten.modal.onlineCheckoutLabel': 'Im Online-Checkout anbieten',
  'zahlarten.modal.onlineCheckoutTooltip': "Gäste können diese Zahlungsart bei der Scan-to-Order-Bestellung wählen. Mit Anbieter 'paypal' zahlt der Gast sofort online — die Bestellung erreicht die Kasse erst nach bestätigter Zahlung. Ohne Anbieter wird an der Kasse bezahlt (z.B. 'Zahlung bei Abholung').",
  'zahlarten.modal.onlineCheckoutHint': 'Für PayPal zusätzlich Anbieter {{code}} eintragen und DATEV-Konto 1210 (SKR03) / 1810 (SKR04) hinterlegen.',

  'zahlarten.modal.shopLabel': 'Im Webshop anbieten',
  'zahlarten.modal.shopTooltip': 'Gilt für den angebundenen Webshop — unabhängig vom Online-Checkout darüber, der die Selbstbestellung per Scan im Laden steuert.',
  'zahlarten.modal.shopHint': 'Zahlarten mit Anbieter (PayPal, Stripe, Mollie) brauchen im Shop Zugangsdaten und werden dort eingerichtet — sie werden von hier nicht übertragen.',

  'zahlarten.modal.conditionsHeading': 'Zahlungskonditionen',
  'zahlarten.modal.paymentTermsLabel': 'Zahlungsziel (Tage)',
  'zahlarten.modal.paymentTermsPlaceholder': 'z.B. 14',
  'zahlarten.modal.discountPercentLabel': 'Skonto (%)',
  'zahlarten.modal.discountPercentPlaceholder': 'z.B. 2',
  'zahlarten.modal.discountDaysLabel': 'Skonto-Frist (Tage)',
  'zahlarten.modal.discountDaysPlaceholder': 'z.B. 10',
  'zahlarten.modal.orderConfirmationTextLabel': 'Text für Auftragsbestätigung',
  'zahlarten.modal.orderConfirmationTextPlaceholder': 'z.B. Zahlbar innerhalb von 14 Tagen, 2% Skonto bei Zahlung innerhalb von 10 Tagen',
  'zahlarten.modal.invoiceTextLabel': 'Text für Rechnung',
  'zahlarten.modal.invoiceTextPlaceholder': 'z.B. Bitte überweisen Sie den Betrag innerhalb von 14 Tagen',

  'zahlarten.modal.activeLabel': 'Aktiv',
  'zahlarten.modal.defaultLabel': 'Standard-Zahlungsart',
  'zahlarten.modal.cancelButton': 'Abbrechen',
  'zahlarten.modal.saveButton': 'Speichern',
  'zahlarten.modal.createButton': 'Erstellen',

  'zahlarten.errors.nameRequired': 'Name ist ein Pflichtfeld',
  'zahlarten.errors.zahlwegRequired': 'Zahlweg ist ein Pflichtfeld — bitte auswählen, womit diese Zahlart eine Eingangsrechnung begleichen kann.',
  'zahlarten.errors.saveFailedPrefix': 'Fehler beim Speichern: ',
  'zahlarten.errors.toggleFailedPrefix': 'Fehler beim Umschalten: ',
  'zahlarten.errors.deleteFailedPrefix': 'Fehler beim Löschen: ',
  'zahlarten.errors.loadFailed': 'Fehler beim Laden der Zahlungsarten',
  'zahlarten.errors.unknown': 'Unbekannter Fehler',
  'zahlarten.errors.forbidden': 'Für diese Aktion wird das Recht „Einstellungen bearbeiten" benötigt.',

  'zahlarten.delete.title': 'Zahlungsart löschen?',
  'zahlarten.delete.text': 'Möchten Sie diese Zahlungsart wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
  'zahlarten.delete.cancelButton': 'Abbrechen',
  'zahlarten.delete.confirmButton': 'Löschen',

  'zahlarten.types.prepayment': 'Vorkasse',
  'zahlarten.types.invoice': 'Rechnung',
  'zahlarten.types.online': 'Online-Zahlung',
  'zahlarten.types.cash': 'Barzahlung',
  'zahlarten.types.other': 'Sonstige',

  'zahlarten.myPortal.sectionTitle': 'Zahlarten für Eingangsrechnungen',
  'zahlarten.myPortal.sectionText': 'Welche Zahlarten stehen zur Auswahl, wenn eine Eingangsrechnung (Lieferantenrechnung) als bezahlt markiert wird — und womit (Kasse, Bank, Verrechnung) wurde tatsächlich bezahlt.',

  // N1 (Korrekturrunde 2, 28.09.2026): Rechte-Hinweise für PosPaymentMethodConfigSection
  // (geteilt zwischen Kundencenter-Kassenverwaltung und JTL-Integration).
  'zahlarten.configSection.readOnlyHint': 'Zum Ändern brauchen Sie das Recht „Einstellungen bearbeiten".',
  'zahlarten.configSection.forbidden': 'Für diese Aktion wird das Recht „Einstellungen bearbeiten" benötigt.',
};
